import { getHeader } from "./user";
import axios from "axios";

export const getUserToken = async () => {
    try {
        const url = `${process.env.REACT_APP_IDWAL_API_URL}/Fleet/v2/token`;
        const header = await getHeader();

        const response = await axios.get(
            url,
            {
                headers: header
            }
        );

        if (response.data) {
            return response.data.token;
        }
    } catch (e) {
        console.error(e);
    }
}